<template>
<transition name="Loader" appear>
  <div class="Loader" :class="{ 'is-hidden': $route.query.forceReload }">
    <div class="Loader__logo is-1" ref="logo1">
      <img :src="require('./img/logo-fr.png')" v-if="lang == 'fr'" />
      <img :src="require('./img/logo-en.png')" v-if="lang == 'en'" />
    </div>
    <div class="Loader__logo is-2" ref="logo2">
      <img :src="require('./img/logo2-fr.png')" v-if="lang == 'fr'" />
      <img :src="require('./img/logo2-en.png')" v-if="lang == 'en'" />
      <button ref="enter" @click="out" class="Loader__enter">{{ trans('enter') }}</button>
    </div>
  </div>
</transition>
</template>

<script>
import Settings from '@/config/Settings'
import chapters from './data/chapters.json'
import pages from './data/pages.json'

export default {
  computed: {
    promises() {
      return this.$store.getters['loader/promises']
    }
  },
  translations: {
    fr: { enter: 'ENTRER' },
    en: { enter: 'ENTER' },
  },
  created() {
    if(Settings.cms && this.$root.mode.dev)
      this.loadWordpress()
    else
      this.loadLocal()

    this.$store.commit('loader/PROMISE_PUSH', new Promise(res => this.resolveTL = res))

    Promise.all(this.promises).then(() => {
      if(this.$route.params.chapter == undefined)
        this.$router.push({ params: { chapter: this.chapters[0][this.lang].slug } })

      if(this.$route.query.forceReload)
        this.$store.commit('loader/LOADER_LOADED')

			if(this.$root.mode.dev)
				this.$store.commit('loader/LOADER_LOADED')
    })
  },
  mounted() {
    const tl = new TimelineMax({
      onComplete: () => this.resolveTL()
    })
    tl
      .to(this.$refs.logo1, 2, { delay: .5, alpha: 1 })
      .to(this.$refs.logo1, 1, { delay: 2, alpha: 0 })
      .to(this.$refs.logo2, 2, { delay: .5, alpha: 1 })
      .to(this.$refs.enter, 1, { alpha: 1 })

    if(this.$root.mode.dev)
      tl.timeScale(50)
  },
  methods: {
    out() {
      const tl = new TimelineMax({ onComplete: () => {
        this.$store.commit('loader/LOADER_LOADED')
      }})

        .to(this.$refs.enter, 1, { alpha: 0 })
        .to(this.$refs.logo2, 1, { alpha: 0 })
    },
    loadLocal() {
      this.$store.commit('data/SET_DATA', { option: false, type: 'pages', data: pages })
      this.$store.commit('data/SET_DATA', { option: false, type: 'chapters', data: chapters })
    },
    loadWordpress() {
      const params = {
        per_page: 500,
        hide_empty: 0,
        orderby: 'menu_order',
        order: 'asc'
      }

      const endpoints = [
        { api: 'pages', option: false },
        { api: 'chapters', option: false },
        // { api: 'general', option: true },
      ]

      _.each(endpoints, endpoint => {
        const url = endpoint.option ? `options/${endpoint.api}` : endpoint.api
        this.$store.commit('loader/PROMISE_PUSH', this.$http.get(url, { params: params })
          .then(res => this.$store.commit('data/SET_DATA', { option: endpoint.option, type: endpoint.api, data: res.data }))
        )
      })
    }
  }
}

</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Loader
  position fixed
  left  0
  right 0
  bottom 0
  top 0
  background-image linear-gradient(to bottom, #020221, #020221)
  z-index 999999
  transition opacity 3s

  &.is-hidden
    display none

  &__enter
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    cursor pointer
    font-size 12px
    font-weight 900
    letter-spacing .2em
    padding 10px 10px 8px
    display block
    border 1px solid white
    font-weight 900
    margin-top 370px
    opacity 0
    color white
    +below(phone)
      margin-top 170px

  &__logo
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    opacity 0
    &.is-1
      width 150px
    &.is-2
      width 225px
      margin-top -120px
      +below(phone)
        width 125px

  &-enter
  &-leave-active
    opacity 0

  &__spin
    position absolute
    left 50%
    margin -15px 0 0 -15px
    border 2px solid rgba(white, .5)
    border-top 2px solid rgba(black, 0)
    border-radius 50%
    width 30px
    height 30px
    animation Loader__spin 2s linear infinite
    bottom 50px

    @keyframes Loader__spin {
      from { transform: rotate(0deg) }
      to { transform: rotate(360deg) }
    }

</style>
